<div
	class="iframe-container"
	[ngClass]="type ? 'iframe-container--tokenizer' : 'iframe-container--embed embed-responsive h-90'"
>
	<iframe
		allowfullscreen
		[class.embed-responsive-item]="!type"
		class="iframe-inner"
		[src]="link"
		[attr.scrolling]="type ? 'no' : null"
	></iframe>
</div>
